(function () {
          var section = document.currentScript.closest('.wagon-pre-bundle-collection');
          if (!section || section.dataset.bundleReady === 'true') return;
          section.dataset.bundleReady = 'true';

          var configEl = section.querySelector('[data-wagon-bundle-config]');
          if (!configEl) return;

	          var config = JSON.parse(configEl.textContent);
	          var products = config.products || {};
	          var inventory = config.inventory || {};
          var inlineSelections = {};

          var bundles = config.bundles || {};
          Object.keys(bundles).forEach(function (key) {
            bundles[key].product = bundles[key].product || key;
          });

          var bundleLayerCdn = 'https://cdn.shopify.com/s/files/1/0561/5891/2694/files/';
          var bundleLayerLabels = ['Midnight Black', 'Moss Green', 'Mocha', 'Sand'];
          var bundleLayerUrls = {
            canopy_left: [
              bundleLayerCdn + 'canopy-left-midnight-black.png',
              bundleLayerCdn + 'canopy-left-forest-green.png',
              bundleLayerCdn + 'canopy-left-mocha.png',
              bundleLayerCdn + 'canopy-left-sand.png'
            ],
            canopy_right: [
              bundleLayerCdn + 'canopy-right-midnight-black.png',
              bundleLayerCdn + 'canopy-right-forest-green.png',
              bundleLayerCdn + 'canopy-right-mocha.png',
              bundleLayerCdn + 'canopy-right-sand.png'
            ],
            basket_left: [
              bundleLayerCdn + 'basket-left-midnight-black.png',
              bundleLayerCdn + 'basket-left-forest-green.png',
              bundleLayerCdn + 'basket-left-mocha.png',
              bundleLayerCdn + 'basket-left-sand.png'
            ],
            basket_right: [
              bundleLayerCdn + 'basket-right-midnight-black.png',
              bundleLayerCdn + 'basket-right-forest-green.png',
              bundleLayerCdn + 'basket-right-mocha.png',
              bundleLayerCdn + 'basket-right-sand.png'
            ],
            snack: bundleLayerCdn + 'snack-tray-both.png',
            bugnet: {
              '0_0': bundleLayerCdn + 'Customize_bugnet_double_B_ac608867-9214-4153-b5fd-d19a02a80a7f.png',
              '1_1': bundleLayerCdn + 'Customize_bugnet_double_G.png',
              '2_2': bundleLayerCdn + 'Customize_bugnet_double_M.png',
              '3_3': bundleLayerCdn + 'Customize_bugnet_double_S.png'
            },
            rainfly: {
              '0_0': bundleLayerCdn + 'Customize_rainfly_double_B_a1aebe1f-e7d3-4bf6-a671-67c8a4b1f5bb.png',
              '1_1': bundleLayerCdn + 'Customize_rainfly_double_G.png',
              '2_2': bundleLayerCdn + 'Customize_rainfly_double_M.png',
              '3_3': bundleLayerCdn + 'Customize_rainfly_double_S.png'
            }
          };

          var navPills = Array.prototype.slice.call(section.querySelectorAll('[data-bundle-filter]'));
          var bundleCards = Array.prototype.slice.call(section.querySelectorAll('[data-bundle-key]'));
          // JCI: Mobile bundle tabs use a fixed grid, so no horizontal-scroll cue is initialized.

          function setActiveNav(filterKey) {
            navPills.forEach(function (pill) {
              var isActive = pill.dataset.bundleFilter === filterKey;
              pill.classList.toggle('active', isActive);
              pill.setAttribute('aria-selected', isActive ? 'true' : 'false');
              pill.tabIndex = isActive ? 0 : -1;
            });
          }

          function setBundleFilter(filterKey) {
            setActiveNav(filterKey);

            bundleCards.forEach(function (card) {
              var isMatch = card.dataset.bundleKey === filterKey;
              card.hidden = !isMatch;
              applyCardCompositor(card, card.dataset.bundleKey, '');
            });

            var selected = bundleCards.find(function (card) { return card.dataset.bundleKey === filterKey; });
            if (selected) renderInlineOptions(selected, filterKey);
          }

          function initBundleFilters() {
            navPills.forEach(function (pill) {
              var filterKey = pill.dataset.bundleFilter;
              if (bundleCards.some(function (card) { return card.dataset.bundleKey === filterKey; })) {
                pill.addEventListener('click', function () {
                  setBundleFilter(filterKey);
                });
                pill.addEventListener('keydown', function (event) {
                  if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
                  event.preventDefault();
                  var direction = event.key === 'ArrowRight' ? 1 : -1;
                  var nextIndex = (navPills.indexOf(pill) + direction + navPills.length) % navPills.length;
                  navPills[nextIndex].focus();
                  setBundleFilter(navPills[nextIndex].dataset.bundleFilter);
                });
              }
            });
            if (bundleCards.length) setBundleFilter(bundleCards[0].dataset.bundleKey);
          }

          function bundleProduct(bundle) {
            return bundle && products[bundle.product];
          }

	          function firstAvailableVariant(product) {
	            if (!product || !product.variants || !product.variants.length) return null;
	            return product.variants.find(function (variant) { return variant.available; }) || product.variants[0];
	          }

	          function withInventory(bundleKey, variant) {
	            if (!variant) return variant;
	            var bundleInventory = inventory[bundleKey] || {};
	            var variantInventory = bundleInventory[String(variant.id)];
	            return variantInventory ? Object.assign({}, variant, variantInventory) : variant;
	          }

	          function colorIndexFromValue(value) {
	            value = String(value || '').toLowerCase();
	            if (value.indexOf('black') !== -1 || value.indexOf('midnight') !== -1) return 0;
	            if (value.indexOf('green') !== -1 || value.indexOf('moss') !== -1 || value.indexOf('forest') !== -1) return 1;
	            if (value.indexOf('sand') !== -1) return 3;
	            return 2;
	          }

	          function normalizeOptionValue(value) {
	            var normalized = String(value || '').toLowerCase().trim();
	            if (normalized.indexOf('black') !== -1 || normalized.indexOf('midnight') !== -1) return 'black';
	            if (normalized.indexOf('green') !== -1 || normalized.indexOf('moss') !== -1 || normalized.indexOf('forest') !== -1) return 'green';
	            if (normalized.indexOf('mocha') !== -1) return 'mocha';
	            if (normalized.indexOf('sand') !== -1) return 'sand';
	            return normalized;
	          }

	          function optionValuesForSelection(bundleKey, selectionMap) {
	            selectionMap = selectionMap || {};
	            var values = bundleOptionGroups(bundleKey).map(function (group) {
	              return selectionMap[group.key] || (group.key === 'basket_all' && selectionMap.canopy_all) || colorLabelByIndex(2);
	            });
	            return values.map(normalizeOptionValue);
	          }

          function setCardLayer(card, name, src) {
            var layer = card && card.querySelector('[data-bundle-card-layer="' + name + '"]');
            if (!layer) return;
            if (src) {
              layer.src = src;
              layer.hidden = false;
            } else {
              layer.removeAttribute('src');
              layer.hidden = true;
            }
          }

          function cardUsesCompositor(bundleKey) {
            var bundle = bundles[bundleKey] || {};
            return !!(bundle.hasCanopy || bundle.basketCount || bundle.hasSnack || bundle.hasBugnet || bundle.hasRainfly);
          }

          function resetCardLayers(card) {
            ['basket_left', 'basket_right', 'canopy_left', 'canopy_right', 'snack', 'bugnet', 'rainfly'].forEach(function (name) {
              setCardLayer(card, name, '');
            });
          }

          function applyCardCompositor(card, bundleKey, colorValue) {
            var compositor = card && card.querySelector('[data-bundle-card-compositor]');
            var staticImage = card && card.querySelector('[data-bundle-static-image]');
            var shouldUse = !!(card && compositor && !card.hidden && cardUsesCompositor(bundleKey));

            if (compositor) compositor.hidden = !shouldUse;
            if (staticImage) staticImage.hidden = shouldUse;
            resetCardLayers(card);
            if (!shouldUse) return;

            var canopyIndex = colorIndexFromValue(colorValue && colorValue.canopy ? colorValue.canopy : colorValue);
            var basketIndex = colorIndexFromValue(colorValue && colorValue.basket ? colorValue.basket : colorValue);
            var bundle = bundles[bundleKey] || {};

            if (bundle.hasCanopy) {
              setCardLayer(card, 'canopy_left', bundleLayerUrls.canopy_left[canopyIndex]);
              setCardLayer(card, 'canopy_right', bundleLayerUrls.canopy_right[canopyIndex]);
            }
            if (bundle.basketCount > 0) {
              setCardLayer(card, 'basket_left', bundleLayerUrls.basket_left[basketIndex]);
            }
            if (bundle.basketCount > 1) {
              setCardLayer(card, 'basket_right', bundleLayerUrls.basket_right[basketIndex]);
            }
            if (bundle.hasBugnet || bundle.hasRainfly) {
              var weatherKey = canopyIndex + '_' + canopyIndex;
              if (bundle.hasBugnet) setCardLayer(card, 'bugnet', bundleLayerUrls.bugnet[weatherKey]);
              if (bundle.hasRainfly) setCardLayer(card, 'rainfly', bundleLayerUrls.rainfly[weatherKey]);
            }
            if (bundle.hasSnack) setCardLayer(card, 'snack', bundleLayerUrls.snack);
          }

          function bundleOptionGroups(bundleKey) {
            var groups = [];
            var bundle = bundles[bundleKey] || {};
            if (bundle.hasCanopy) {
              groups.push({ key: 'canopy_all', title: 'Choose canopy color' });
            }
            if (bundle.basketCount > 0) {
              groups.push({ key: 'basket_all', title: 'Choose basket color' });
            }
            return groups;
          }

          function colorLabelByIndex(index) {
            return bundleLayerLabels[index] || bundleLayerLabels[2];
          }

          function defaultColorIndex(bundleKey, groupKey) {
            inlineSelections[bundleKey] = inlineSelections[bundleKey] || {};
            var current = inlineSelections[bundleKey][groupKey];
            if (current) return colorIndexFromValue(current);
            inlineSelections[bundleKey][groupKey] = colorLabelByIndex(2);
            return 2;
          }

          function setInlineSelection(bundleKey, groupKey, value) {
            inlineSelections[bundleKey] = inlineSelections[bundleKey] || {};
            inlineSelections[bundleKey][groupKey] = value;
          }

          function applyCardCompositorFromSelections(card, bundleKey) {
            var selectionMap = inlineSelections[bundleKey] || {};
            var canopyColor = selectionMap.canopy_all || colorLabelByIndex(defaultColorIndex(bundleKey, 'canopy_all'));
            var basketColor = selectionMap.basket_all || canopyColor;
            applyCardCompositor(card, bundleKey, {
              canopy: canopyColor,
              basket: basketColor
            });
          }

	          function renderInlineOptions(card, bundleKey) {
	            if (!card) return;
	            var container = card.querySelector('[data-wagon-inline-options]');
	            var backorder = card.querySelector('[data-wagon-inline-backorder]');
	            var error = card.querySelector('[data-wagon-inline-error]');
	            var groups = bundleOptionGroups(bundleKey);
	            if (backorder) {
	              backorder.hidden = true;
	              backorder.textContent = '';
	            }
	            if (error) {
	              error.hidden = true;
	              error.textContent = '';
            }
            if (!container) return;
            container.innerHTML = '';
            if (!groups.length) {
              applyCardCompositor(card, bundleKey, '');
              container.hidden = true;
              return;
            }

            groups.forEach(function (groupConfig) {
              var currentIndex = defaultColorIndex(bundleKey, groupConfig.key);
              var group = document.createElement('div');
              group.className = 'inline-bundle-options__group';
              group.innerHTML = '<div class="inline-bundle-options__head"><strong>' + groupConfig.title + '</strong></div><div class="inline-bundle-options__choices"></div>';
              var choices = group.querySelector('.inline-bundle-options__choices');

              [2, 3, 1, 0].forEach(function (index) {
                var value = colorLabelByIndex(index);
                var button = document.createElement('button');
                button.type = 'button';
                button.className = 'inline-bundle-options__choice';
                button.setAttribute('aria-pressed', index === currentIndex ? 'true' : 'false');
                if (index === currentIndex) button.classList.add('is-selected');
                button.innerHTML = '<span class="inline-bundle-options__dot"></span><span>' + value + '</span>';
                var dot = button.querySelector('.inline-bundle-options__dot');
                if (index === 0) dot.classList.add('is-black');
                if (index === 1) dot.classList.add('is-green');
                if (index === 2) dot.classList.add('is-mocha');
                if (index === 3) dot.classList.add('is-sand');
                button.addEventListener('click', function () {
                  setInlineSelection(bundleKey, groupConfig.key, value);
                  renderInlineOptions(card, bundleKey);
                });
                choices.appendChild(button);
              });

              container.appendChild(group);
            });

	            applyCardCompositorFromSelections(card, bundleKey);
	            updateCardBackorder(card, bundleKey);
	            container.hidden = false;
	          }

          function showCardError(button, message) {
            var card = button && button.closest ? button.closest('[data-bundle-key]') : null;
            var error = card && card.querySelector('[data-wagon-inline-error]');
            if (error) {
              error.textContent = message;
              error.hidden = false;
            }
          }

          function clearCardError(button) {
            var card = button && button.closest ? button.closest('[data-bundle-key]') : null;
            var error = card && card.querySelector('[data-wagon-inline-error]');
            if (error) {
              error.textContent = '';
              error.hidden = true;
            }
          }

	          function variantTitle(variant) {
	            if (!variant) return '';
	            return String(variant.title || '').indexOf('Default') === -1 ? variant.title : '';
	          }

	          function isBackorderedVariant(variant) {
	            if (!variant || !variant.available) return false;
	            if (!variant.inventory_management) return false;
	            return Number(variant.inventory_quantity || 0) < 1;
	          }

	          function backorderMessage(product, variant) {
	            var title = product && product.title ? product.title : 'This bundle';
	            var optionTitle = variantTitle(variant);
	            return title + (optionTitle ? ' - ' + optionTitle : '') + ' is backordered and will ship as soon as it is back in stock.';
	          }

	          function updateBackorderElement(element, product, variant) {
	            if (!element) return;
	            if (isBackorderedVariant(variant)) {
	              element.textContent = backorderMessage(product, variant);
	              element.hidden = false;
	            } else {
	              element.textContent = '';
	              element.hidden = true;
	            }
	          }

	          function updateCardBackorder(card, bundleKey) {
	            if (!card) return;
	            var bundle = bundles[bundleKey];
	            var product = bundleProduct(bundle);
	            var selectionMap = inlineSelections[bundleKey] || {};
	            var variant = selectedVariant(bundle, selectionMap, bundleKey);
	            updateBackorderElement(card.querySelector('[data-wagon-inline-backorder]'), product, variant);
	          }

	          function missingProducts(bundle) {
            var product = bundleProduct(bundle);
            return !product || !product.variants || !product.variants.length;
          }

	          function selectedVariant(bundle, selectionMap, bundleKey) {
	            var product = bundleProduct(bundle);
	            if (!product || !product.variants || !product.variants.length) return null;

	            var activeSelections = selectionMap || {};
	            var expectedOptions = optionValuesForSelection(bundleKey, activeSelections);
	            if (!expectedOptions.length) return withInventory(bundleKey, firstAvailableVariant(product));

	            var matchedVariant = product.variants.find(function (variant) {
	              if (!variant.available || !variant.options) return false;
	              return expectedOptions.every(function (expectedValue, index) {
	                return normalizeOptionValue(variant.options[index]) === expectedValue;
	              });
	            }) || firstAvailableVariant(product);
	            return withInventory(bundleKey, matchedVariant);
	          }

          function setButtonLoading(button, loading) {
            if (!button) return;
            if (!button.dataset.defaultText) button.dataset.defaultText = button.textContent;
            button.disabled = loading;
            button.classList.toggle('is-loading', loading);
            button.textContent = loading ? 'Adding...' : button.dataset.defaultText;
          }

          function addBundle(bundle, button, bundleKey) {
            if (missingProducts(bundle)) {
              showCardError(button, 'Please choose the bundle product in this section settings before adding.');
              return Promise.resolve();
            }

            var selectionMap = inlineSelections[bundleKey] || {};
            var variant = selectedVariant(bundle, selectionMap, bundleKey);
            if (!variant) {
              showCardError(button, 'No available variant matches the selected options.');
              return Promise.resolve();
            }

            clearCardError(button);
            setButtonLoading(button, true);

	            var item = { id: variant.id, quantity: 1 };

            return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({ items: [item] })
            }).then(function (response) {
              if (!response.ok) {
                return response.json().then(function (data) {
                  throw new Error(data.description || data.message || 'Could not add this bundle to cart.');
                });
              }
              document.dispatchEvent(new CustomEvent('theme:cartchanged', {
                bubbles: true,
                cancelable: false,
                detail: { openDrawer: true }
              }));
            }).catch(function (error) {
              showCardError(button, error.message || 'Could not add this bundle to cart.');
            }).finally(function () {
              setButtonLoading(button, false);
            });
          }

          section.querySelectorAll('[data-wagon-bundle-add]').forEach(function (button) {
            button.addEventListener('click', function () {
              var bundleKey = button.dataset.wagonBundleAdd;
              var bundle = bundles[bundleKey];
              if (!bundle) return;
              clearCardError(button);

              if (missingProducts(bundle)) {
                showCardError(button, 'Please choose the bundle product in this section settings before adding.');
                return;
              }

              var card = button.closest('[data-bundle-key]');
              var groups = bundleOptionGroups(bundleKey);
              if (groups.length) renderInlineOptions(card, bundleKey);

              addBundle(bundle, button, bundleKey);
            });
          });
          initBundleFilters();
        })();
